import React, {Component, Fragment} from "react";
import {createPoll, updatePoll, getUserCategories, getUserCards} from "../util/APIUtils";
import {POLL_QUESTION_MAX_LENGTH} from "../constants";
import "./NewPoll.scss";
import {Button, DatePicker, Form, Input, Modal, notification, Select, Switch} from "antd";
import {
    DeleteOutlined, PlusOutlined, QuestionCircleOutlined
} from "@ant-design/icons";
import moment from "moment";
import {CATEGORY_ICONS} from "../constants/icons";

const FormItem = Form.Item;
const {TextArea} = Input;
const {Option} = Select;
const dateFormat = "YYYY/MM/DD";


class NewChitiItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            question: {
                text: ""
            },
            amount: {
                text: ""
            },
            category: {
                text: ""
            },
            card: {
                text: ""
            },
            store: {
                text: ""
            },
            items: [],
            useItemList: false,
            categories: [],
            cards: [],
            inputDate: {
                date: new Date()
            },
            showHelpModal: false
        };
        this.addChoice = this.addChoice.bind(this);
        this.removeChoice = this.removeChoice.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleQuestionChange = this.handleQuestionChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleInputDateChange = this.handleInputDateChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleCardChange = this.handleCardChange.bind(this);
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.isFormInvalid = this.isFormInvalid.bind(this);
    }

    componentDidMount() {
        getUserCategories()
            .then(response => {
                this.setState({ categories: response });
            })
            .catch(error => {
                console.error('Failed to load categories:', error);
            });
        
        getUserCards()
            .then(response => {
                this.setState({ cards: response });
            })
            .catch(error => {
                console.error('Failed to load cards:', error);
            });

        if (this.props.item) {
            this.setState({
                category: {text: this.props.item.category},
                amount: {text: this.props.item.price},
                question: {text: this.props.item.description},
                card: {text: this.props.item.cardName || ''},
                store: {text: this.props.item.store || ''},
                items: (this.props.item.items || []).map(l => ({ name: l.name, price: l.price, quantity: l.quantity })),
                useItemList: (this.props.item.items || []).length > 0,
                inputDate: {date: moment(this.props.item.tradingDate, 'YYYY-MM-DD').toDate()},
                id: this.props.item.id
            });
        }
    }

    addChoice(event) {
        const choices = this.state.choices.slice();
        this.setState({
            choices: choices.concat([
                {
                    text: ""
                }
            ])
        });
    }

    removeChoice(choiceNumber) {
        const choices = this.state.choices.slice();
        this.setState({
            choices: [
                ...choices.slice(0, choiceNumber),
                ...choices.slice(choiceNumber + 1)
            ]
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const paymentData = {
            id: this.state.id,
            description: this.state.question.text.trim(),
            price: this.state.amount.text,
            tradingDate: moment(this.state.inputDate.date).format('YYYY-MM-DD'),
            category: this.state.category.text.trim(),
            cardName: this.state.card.text ? this.state.card.text.trim() : '',
            store: this.state.store.text ? this.state.store.text.trim() : '',
            items: this.state.items
                .filter(l => l.name && l.name.trim())
                .map(l => ({ name: l.name.trim(), price: parseFloat(l.price) || 0, quantity: parseInt(l.quantity) || 1 })),
            priceUnit: "VND"
        };

        if (this.props.item) {
            updatePoll(paymentData)
                .then(response => {
                    notification.success({
                        message: ":D",
                        description: "success!"
                    });
                    return this.props.closeModal();
                })
                .catch(error => {
                    if (error.status === 401) {
                        this.props.handleLogout(
                            "/login",
                            "error",
                            "You have been logged out. Please login create poll."
                        );
                    } else {
                        notification.error({
                            message: ":(",
                            description:
                                error.message ||
                                "Sorry! Something went wrong. Please try again!"
                        });
                    }
                });
        } else {
            createPoll(paymentData)
                .then(response => {
                    notification.success({
                        message: ":D",
                        description: "success!"
                    });
                    return this.props.closeModal();
                })
                .catch(error => {
                    if (error.status === 401) {
                        this.props.handleLogout(
                            "/login",
                            "error",
                            "You have been logged out. Please login create poll."
                        );
                    } else {
                        notification.error({
                            message: ":(",
                            description:
                                error.message ||
                                "Sorry! Something went wrong. Please try again!"
                        });
                    }
                });
        }
    }

    validateQuestion = questionText => {
        if (questionText.length === 0) {
            return {
                validateStatus: "error",
                errorMsg: "Please enter your question!"
            };
        } else if (questionText.length > POLL_QUESTION_MAX_LENGTH) {
            return {
                validateStatus: "error",
                errorMsg: `Question is too long (Maximum ${POLL_QUESTION_MAX_LENGTH} characters allowed)`
            };
        } else {
            return {
                validateStatus: "success",
                errorMsg: null
            };
        }
    };

    handleQuestionChange(event) {
        const value = event.target.value;
        this.setState({
            question: {
                text: value,
                ...this.validateQuestion(value)
            }
        });
    }

    handleAmountChange(event) {
        const value = event.target.value;
        this.setState({
            amount: {
                text: value,
                ...this.validateQuestion(value)
            }
        });
    }

    getCategoryOptions = () => {
        return this.state.categories
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(cat => {
                const iconData = CATEGORY_ICONS.find(i => i.value === cat.icon);
                const emoji = iconData ? iconData.label.split(' ')[0] : '💵';

                return (
                    <Option key={cat.id} value={cat.name}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '16px' }}>{emoji}</span>
                            <span>{cat.name}</span>
                        </div>
                    </Option>
                );
            });
    }

    handleCategoryChange = (value) => {
        this.setState({
            category: { text: value }
        });
    }

    handleCardChange = (value) => {
        this.setState({
            card: { text: value }
        });
    }

    handleStoreChange(event) {
        this.setState({
            store: { text: event.target.value }
        });
    }

    getItemsTotal = (items) => {
        return items.reduce((sum, l) => sum + (parseFloat(l.price) || 0) * (parseInt(l.quantity) || 1), 0);
    }

    addItem = () => {
        this.setState(prev => ({ items: [...prev.items, { name: '', price: '', quantity: 1 }] }));
    }

    removeItem = (index) => {
        this.setState(prev => {
            const items = prev.items.filter((_, i) => i !== index);
            const total = this.getItemsTotal(items);
            return { items, amount: { text: total > 0 ? total : '' } };
        });
    }

    updateItem = (index, field, value) => {
        this.setState(prev => {
            const items = [...prev.items];
            items[index] = { ...items[index], [field]: value };
            const total = this.getItemsTotal(items);
            return { items, amount: { text: total > 0 ? total : prev.amount.text } };
        });
    }


    showHelpModal = () => {
        this.setState({ showHelpModal: true });
    }

    hideHelpModal = () => {
        this.setState({ showHelpModal: false });
    }


    handleInputDateChange(date, dateString) {
        this.setState({
            inputDate: {
                date: date !== null ? date.toDate() : moment()
            }
        });
    }

    isFormInvalid() {
        return false;
    }

    render() {
        const { category, card, store, amount, question, inputDate, cards, useItemList } = this.state;
        const isEdit = !!this.props.item;

        return (
            <div>
                <Form layout="vertical" onSubmit={this.handleSubmit}>

                    {/* ── Amount blue card ── */}
                    <div style={{
                        background: '#f0f7ff',
                        border: '1px solid #91caff',
                        borderRadius: '14px',
                        padding: '16px 20px',
                        marginBottom: '16px'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                            <span style={{ color: '#1890ff', fontSize: '13px', fontWeight: 600 }}>
                                {useItemList ? `Total — ${this.state.items.length} item${this.state.items.length !== 1 ? 's' : ''}` : 'Amount'}
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ color: '#8c8c8c', fontSize: '12px' }}>Item list</span>
                                <Switch
                                    size="small"
                                    checked={useItemList}
                                    onChange={checked => this.setState({ useItemList: checked, items: [], amount: { text: '' } })}
                                />
                            </div>
                        </div>
                        {!useItemList ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <span style={{ color: '#262626', fontSize: '36px', fontWeight: 700 }}>$</span>
                                <input
                                    placeholder="0.00"
                                    type="text"
                                    inputMode="decimal"
                                    value={amount.text}
                                    onChange={e => {
                                        const v = e.target.value;
                                        if (v === '' || /^\d*\.?\d*$/.test(v)) this.handleAmountChange(e);
                                    }}
                                    style={{
                                        fontSize: '36px',
                                        fontWeight: 700,
                                        background: 'transparent',
                                        border: 'none',
                                        borderBottom: '2px solid #91caff',
                                        borderRadius: 0,
                                        color: '#262626',
                                        outline: 'none',
                                        width: '100%',
                                        padding: '0 4px',
                                    }}
                                />
                            </div>
                        ) : (
                            <div style={{ fontSize: '36px', fontWeight: 700, color: '#262626', letterSpacing: '-0.5px' }}>
                                ${amount.text || '0.00'}
                            </div>
                        )}
                    </div>

                    {/* ── Item list ── */}
                    {useItemList && (
                        <div style={{ marginBottom: '16px' }}>
                            {this.state.items.map((line, index) => (
                                <div key={index} style={{
                                    display: 'flex',
                                    gap: '8px',
                                    marginBottom: '8px',
                                    alignItems: 'center',
                                    background: '#f7f9fc',
                                    borderRadius: '10px',
                                    padding: '8px 10px',
                                    border: '1px solid #e8edf3'
                                }}>
                                    <Input
                                        placeholder="Item name"
                                        value={line.name}
                                        size="large"
                                        onChange={e => this.updateItem(index, 'name', e.target.value)}
                                        style={{ flex: 2 }}
                                    />
                                    <Input
                                        placeholder="Price"
                                        type="number"
                                        step="any"
                                        value={line.price}
                                        size="large"
                                        onChange={e => this.updateItem(index, 'price', e.target.value)}
                                        style={{ flex: 1 }}
                                    />
                                    <Input
                                        placeholder="Qty"
                                        type="number"
                                        value={line.quantity}
                                        size="large"
                                        onChange={e => this.updateItem(index, 'quantity', e.target.value)}
                                        style={{ width: '64px' }}
                                    />
                                    <Button
                                        type="text"
                                        danger
                                        onClick={() => this.removeItem(index)}
                                    >
                                        <DeleteOutlined />
                                    </Button>
                                </div>
                            ))}
                            <Button
                                type="dashed"
                                onClick={this.addItem}
                                icon={<PlusOutlined />}
                                block
                                size="large"
                                style={{ borderRadius: '10px' }}
                            >
                                Add item
                            </Button>
                        </div>
                    )}

                    {/* ── Date & Store ── */}
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                        <FormItem label="Date" style={{ flex: 1, margin: 0 }}>
                            <DatePicker
                                style={{ width: '100%' }}
                                size="large"
                                format={dateFormat}
                                onChange={this.handleInputDateChange}
                                value={moment(inputDate.date, dateFormat)}
                            />
                        </FormItem>
                        <FormItem label="Store" style={{ flex: 1, margin: 0 }}>
                            <Input
                                placeholder="Store (optional)"
                                size="large"
                                value={store.text}
                                onChange={this.handleStoreChange}
                            />
                        </FormItem>
                    </div>

                    {/* ── Category & Card ── */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
                        <FormItem style={{ margin: 0 }}
                            label={
                                <span>
                                    Category
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={this.showHelpModal}
                                        style={{ padding: '0 4px', fontSize: '13px', height: 'auto', color: '#1890ff' }}
                                    >
                                        <QuestionCircleOutlined />
                                    </Button>
                                </span>
                            }
                        >
                            <Select
                                placeholder="Select category"
                                size="large"
                                value={category.text || undefined}
                                onChange={this.handleCategoryChange}
                                style={{ width: '100%' }}
                            >
                                {this.getCategoryOptions()}
                            </Select>
                        </FormItem>
                        <FormItem
                            style={{ flex: 1, margin: 0 }}
                            label={
                                <span>
                                    Card
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={this.showHelpModal}
                                        style={{ padding: '0 4px', fontSize: '13px', height: 'auto', color: '#1890ff' }}
                                    >
                                        <QuestionCircleOutlined />
                                    </Button>
                                </span>
                            }
                        >
                            <Select
                                placeholder="Card (optional)"
                                size="large"
                                value={card.text || undefined}
                                onChange={this.handleCardChange}
                                allowClear
                                style={{ width: '100%' }}
                            >
                                {cards.sort((a, b) => a.name.localeCompare(b.name)).map(c => (
                                    <Option key={c.id} value={c.name}>{c.name}</Option>
                                ))}
                            </Select>
                        </FormItem>
                    </div>

                    {/* ── Description ── */}
                    <FormItem style={{ marginBottom: '20px' }}>
                        <TextArea
                            placeholder="Note (optional)"
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            value={question.text}
                            onChange={this.handleQuestionChange}
                            style={{ fontSize: '15px', borderRadius: '10px' }}
                        />
                    </FormItem>

                    {/* ── Submit ── */}
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        disabled={this.isFormInvalid()}
                        style={{ height: '48px', fontSize: '16px', fontWeight: 600, borderRadius: '10px' }}
                        onClick={this.handleSubmit}
                    >
                        {isEdit ? 'Update Expense' : 'Add Expense'}
                    </Button>
                </Form>

                {/* Help Modal */}
                <Modal
                    title="How to Add Categories & Cards"
                    open={this.state.showHelpModal}
                    visible={this.state.showHelpModal}
                    onCancel={this.hideHelpModal}
                    footer={<Button type="primary" onClick={this.hideHelpModal}>Got it</Button>}
                    width={360}
                >
                    <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
                        <p>Go to your <strong>Profile</strong> page:</p>
                        <ol style={{ paddingLeft: '20px' }}>
                            <li>Click your profile icon in the header</li>
                            <li><strong>Categories</strong> tab → add categories</li>
                            <li><strong>Cards</strong> tab → add payment cards</li>
                        </ol>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default NewChitiItem;
